"use strict";
/**
 * This is meant to be a place where we can type out all possible local images
 * that are supported by the frontends
 */
Object.defineProperty(exports, "__esModule", { value: true });
